import { render, staticRenderFns } from "./create-issue.vue?vue&type=template&id=fe5ca13a&scoped=true"
import script from "./create-issue.vue?vue&type=script&lang=js"
export * from "./create-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5ca13a",
  null
  
)

export default component.exports